export default "__VITE_ASSET__BStdgdYu__"